<template>
  <el-container class="layout">
    <el-aside width="220px" class="sidebar">
      <div class="brand">防伪核验后台</div>
      <el-menu
        router
        :default-active="$route.path"
        background-color="#1f2937"
        text-color="#d1d5db"
        active-text-color="#fff"
      >
        <el-menu-item v-for="item in menu" :key="item.path" :index="item.path">
          <i :class="item.icon"></i>
          <span slot="title">{{ item.label }}</span>
        </el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header class="header">
        <strong>{{ title }}</strong>
        <el-button size="small" class="btn-logout" icon="el-icon-switch-button" @click="logout">退出</el-button>
      </el-header>
      <el-main class="content">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { menu, titleByPath } from '../menu'

export default {
  data() {
    return { menu }
  },
  computed: {
    title() {
      return this.$route.meta.title || titleByPath(this.$route.path)
    }
  },
  methods: {
    logout() {
      localStorage.removeItem('ANTI_ADMIN_TOKEN')
      this.$router.replace('/login')
    }
  }
}
</script>
